import http from '@/services/http';

export interface ImportErrorItem {
  row: number;
  column: string;
  value: string | null;
  reason: string;
}

export interface ImportSkippedItem {
  row: number;
  serial_number: string;
  reason: string;
}

export interface VariboxImportReport {
  dry_run: boolean;
  validation_passed: boolean;
  total_rows: number;
  importable_rows: number;
  imported: number;
  skipped_existing: number;
  errors: ImportErrorItem[];
  clients_created: number;
  existing_clients_reused: number;
  pl01_count: number;
  pl99_count: number;
  skipped: ImportSkippedItem[];
}

async function sendImportRequest(file: File, dryRun: boolean): Promise<VariboxImportReport> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await http.post<VariboxImportReport>(`/api/variboxes/import?dry_run=${dryRun ? 'true' : 'false'}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}

export async function validateVariboxImport(file: File): Promise<VariboxImportReport> {
  return sendImportRequest(file, true);
}

export async function executeVariboxImport(file: File): Promise<VariboxImportReport> {
  return sendImportRequest(file, false);
}